const defaultWidth = 16;
const defaultHeight = 16;

export const WordFillIcon = ({ width = defaultWidth, height = defaultHeight, color = '#005CC5' }: SvgProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform={`scale(${width / defaultWidth}, ${height / defaultHeight})`}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.37272 1.67318C10.2061 1.58984 10.9292 2.24425 10.9292 3.08176V12.9169C10.9292 13.7544 10.2061 14.4089 9.37272 14.3255L3.27474 13.7157C2.55109 13.6434 2 13.0344 2 12.3071V3.69155C2 2.96428 2.55109 2.35534 3.27474 2.28298L9.37272 1.67318ZM11.7141 13.5526H12.9972C13.779 13.5526 14.4128 12.9189 14.4128 12.137V4.29679C14.4128 3.51497 13.779 2.88118 12.9972 2.88118H11.7141V3.97011H12.9972C13.1776 3.97011 13.3239 4.11637 13.3239 4.29679V12.137C13.3239 12.3175 13.1776 12.4637 12.9972 12.4637H11.7141V13.5526ZM3.06673 5.66602L4.40805 10.4984H5.46699L6.31415 7.52153H6.35265L7.1998 10.4984H8.25232L9.60007 5.66602H8.39352L7.67472 8.87646H7.64263L6.82757 5.66602H5.83281L5.02416 8.86979H4.98566L4.27328 5.66602H3.06673Z"
        fill={color}
      />
    </g>
  </svg>
);
